var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stateCell"},[_c('span',[_vm._v(_vm._s(_vm.row[_vm.column.key] == '0' ? '否' : '是'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }